import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Archive } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import axiosService from '../../../../../../../utils/AxiosService'
import { useParams } from 'react-router-dom'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'
import { ARCHIVED_STATUS_KEY } from '../../../../../../../utils/statusDisplayName'

export default observer(function CampaignInfluencerBottomNavBtns() {
  const { campaign, authentications } = useContext(CampaignContext)
  const readOnly = useReadOnly()
  const { campaign_authentication_id } = useParams()
  const auth = authentications.find(auth => +auth.campaign_authentication_id === +campaign_authentication_id)

  const handleArchive = () => {
      const archStatusId = campaign.statuses.find(status => status.system_key === ARCHIVED_STATUS_KEY)?.id
      if (!archStatusId) return toastError('This campaign has no Archived list')
      auth.status_id = archStatusId
      axiosService.patch(
          `/api/project_manager/campaigns/${campaign.id}/campaign_authentications/${campaign_authentication_id}`,
          { campaign_authentication: { status_id: archStatusId } }
      )
      .then(toastSuccess('Influencer has been moved to archive'))
      .catch(error => {
          console.log(error)
      })
  }
  
  return (
    <div className="w-full bg-white border-t-1 border-border-primary mt-4 py-4 flex justify-between">
      <button 
        className='bg-rb-green py-2 px-4 rounded-lg flex items-center gap-2'
        onClick={() => window.open(`/project_manager/authentications/${auth.authentication_id}/influencer/overview`, '_blank', 'noopener,noreferrer')}
      >
        <span className="font-bold text-white">View full profile</span>
      </button>
      {!readOnly && (
        <button
          className="bg-rb-lite-grey py-2 px-4 rounded-lg flex items-center gap-2"
          onClick={handleArchive}
        >
          <Archive />
          <span className="font-bold">Move to archive</span>
        </button>
      )}
    </div>
  )
})